export default  {
  bindings: {
    period: '=',
    title: '@'
  },
  controller: 'periodsSaveController',
  template: require('../views/periods.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/components/periods.save.component.js